import axios from 'axios';
import get from 'lodash-es/get';
import { store } from '../index.js';
import { countBy } from 'lodash-es';
import { initializeSegment } from '@services/segment';
import { BookingSelectors } from '@redux/BookingRedux';
import { AuthSelectors } from '@redux/AuthRedux';
import { AppSelectors } from '@redux/AppRedux';
import { CleansSelectors } from '@redux/CleansRedux';
import { SERVICE_TYPES, CLEANS_LIST_TYPE } from '@services/minte';
import logger from '@utils/logger';
import moment from 'moment';

initializeSegment();
//helpers functions

const loadBranchAndGetFingerprint = new Promise(function(resolve, reject) {
  window.branch.init(process.env.BRANCH_KEY, {}, function(err, data) {
    window.branch.getBrowserFingerprintId(function(err, fingerprint) {
      // fetch the browser fingerprint from the SDK
      if (err) {
        reject(err);
        return;
      }
      resolve({ ...data, fingerprint });
    });
  });
});

export const fmtUserInfo = async state => {
  let officeName;
  if (state.auth.me.office) {
    officeName = state.auth.me.office.name;
  }

  const { fingerprint } = await loadBranchAndGetFingerprint;
  return {
    office: officeName,
    propertyName: state.auth.me.propertyName,
    firstName: state.auth.me.firstName,
    lastName: state.auth.me.lastName,
    email: state.auth.me.email,
    userId: state.auth.me.userID,
    datetime: new Date().toLocaleString(),
    browser_fingerprint_id: fingerprint
  };
};

const getRecSrvCts = selectedItems => {
  const serviceCts = countBy(selectedItems, clean => clean.serviceType);
  return {
    [SERVICE_TYPES.HOTEL_STYLE]: 0,
    [SERVICE_TYPES.DEEP_CLEAN]: 0,
    ...serviceCts
  };
};

const fmtRecurInitialFields = state => {
  const serviceCts = getRecSrvCts(state.schedule.selectedItems);
  return {
    recurring: state.schedule.allPackages[state.schedule.currentPackage].title,
    hotelStyleCt: serviceCts[SERVICE_TYPES.HOTEL_STYLE],
    deepCleanCt: serviceCts[SERVICE_TYPES.DEEP_CLEAN],
    cycleLength: state.schedule.numOfRows
  };
};

const recurAddSvcsformatter = state => {
  const addonsArray = state.schedule.selectedItems
    .map(clean => {
      return clean.addons ? clean.addons : [];
    })
    .flat();
  return getAddServicesTitles(addonsArray, state);
};

//end helpers

//signup/login flow

export async function segmentAlias(userID) {
  try {
    analytics.alias(userID);
  } catch (err) {
    logger.log('segmentAlias', err);
  }
}

export async function segmentIdentify(state) {
  try {
    const userInfo = await fmtUserInfo(state);
    let phone = '';
    if (state.auth.me.phone && state.auth.me.phone !== '') {
      phone = `1${state.auth.me.phone.replace(/\D/g, '')}`;
    }
    analytics.identify(state.auth.me.userID, {
      ...userInfo,
      phone: phone,
      createdAt: state.auth.me.createdAt,
      socialSource: state.auth.me.dataSource
    });
  } catch (err) {
    logger.log('segmentIdentify', err);
  }
}

export async function trackRecurringStatus(state) {
  try {
    const userInfo = await fmtUserInfo(state);
    let recurringStatus;
    if (state.subscription.data) {
      recurringStatus = state.subscription.data.status;
    }
    analytics.track('Recurring Status', {
      ...userInfo,
      recurringStatus: recurringStatus
    });
  } catch (err) {
    logger.log('trackRecurringStatus', err);
  }
}

export async function trackEmailEntered(values) {
  try {
    const { fingerprint } = await loadBranchAndGetFingerprint;
    analytics.track('Sign Up - Email Entered', {
      email: values.email,
      datetime: new Date().toLocaleString(),
      browser_fingerprint_id: fingerprint
    });
  } catch (err) {
    logger.log('trackEmailEntered', err);
  }
}

export async function trackLogIn(state) {
  try {
    const userInfo = await fmtUserInfo(state);
    analytics.track('Log In', {
      ...userInfo,
      socialSource: state.auth.me.dataSource
    });
  } catch (err) {
    logger.log('trackLogIn', err);
  }
}

export async function trackSignUp(state) {
  try {
    const { fingerprint } = await loadBranchAndGetFingerprint;

    analytics.track('Sign Up - Create User Account', {
      firstName: state.auth.me.firstName,
      lastName: state.auth.me.lastName,
      email: state.auth.me.email,
      userId: state.auth.me.userID,
      phone: state.auth.me.phone,
      socialSource: state.auth.me.dataSource,
      browser_fingerprint_id: fingerprint
    });
  } catch (err) {
    logger.log('trackSignUp', err);
  }
}

export async function trackBuildingAdded(userInfo, state) {
  try {
    analytics.track('Sign Up - Building Added', {
      ...userInfo,
      buildingName: state.auth.me.buildingName,
      unitNo: state.auth.me.unitNumber,
      bedroomCt: state.auth.me.bedroomsCount,
      pets: state.auth.me.hasPets,
      optInNewsLetter: state.auth.me.optInNewsLetter,
      isTextNotificationAllow: state.auth.me.isTextNotificationAllow
    });
  } catch (err) {
    logger.log('trackBuildingAdded', err);
  }
}
export async function trackBuildingRequest(payload) {
  try {
    const state = store.getState();
    await fmtUserInfo(state);
    analytics.track('Building Request', {
      firstName: state.auth.me.firstName,
      lastName: state.auth.me.lastName,
      email: state.auth.me.email,
      userId: state.auth.me.userID,
      city: payload.city,
      propertyManagementEmail: payload.email,
      propertyManagementName: payload.pm_name,
      propertyManagementPhone: payload.phone,
      propertyName: payload.property_name,
      state: payload.state
    });
  } catch (err) {
    logger.log('trackBuildingRequest', err);
  }
}

const fmtRecipientInfo = (state, buildingDetails = false) => {
  const recipient = BookingSelectors.selectRecipientInfo(state);
  let recipientInfo = {
    residentFirstName: recipient.firstName,
    residentLastName: recipient.lastName,
    residentEmail: recipient.email,
    propertyName: recipient.propertyName
  };

  if (buildingDetails) {
    recipientInfo = {
      ...recipientInfo,
      buildingName: recipient.buildingName,
      unitNo: recipient.unitNumber,
      bedroomCt: recipient.bedroomsCount
    };
  }
  return recipientInfo;
};

export async function trackPMResidentSelected(userInfo, state) {
  try {
    const recipientInfo = fmtRecipientInfo(state, true);
    analytics.track('PM Resident Selected', {
      ...userInfo,
      ...recipientInfo
    });
  } catch (err) {
    logger.log('trackPMResidentSelected', err);
  }
}

export async function trackKeyRelease() {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    analytics.track('Sign Up - Key Release', {
      ...userInfo
    });
  } catch (err) {
    logger.log('trackKeyRelease', err);
  }
}

export async function trackLogOut() {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    analytics.track('Log Out', {
      ...userInfo
    });
    analytics.reset();
  } catch (err) {
    logger.log('trackLogOut', err);
  }
}

//end signup/login flow

const getAddServicesTitles = (addonArray, state) => {
  const appData = AppSelectors.selectAppData(state);
  const addServices = addonArray.map(addon => appData.addons[addon].title);
  return addServices;
};

const getServiceTitle = (internalServiceType, state) => {
  const appData = AppSelectors.selectAppData(state);
  return appData.serviceTypes[internalServiceType].title;
};

//Booking Flow
export async function trackServiceFreqSel(userInfo, state) {
  try {
    analytics.track('Service Frequency Selected', {
      ...userInfo,
      serviceFrequency: state.booking.frequency
    });
  } catch (err) {
    logger.log('trackServiceFreqSel', err);
  }
}
// Onetime track calls
export async function trackOnetimeLvlSel(userInfo, state) {
  try {
    const serviceTitle = getServiceTitle(state.booking.serviceType, state);
    analytics.track('Onetime Level Selected', {
      ...userInfo,
      serviceType: serviceTitle
    });
  } catch (err) {
    logger.log('trackOnetimeLvlSel', err);
  }
}

export async function trackOnetimeAddSrvcs(userInfo, state) {
  try {
    const serviceTitle = getServiceTitle(state.booking.serviceType, state);
    const addServices = getAddServicesTitles(state.booking.addons, state);
    analytics.track('Onetime Add Services Selected', {
      ...userInfo,
      serviceType: serviceTitle,
      addServices: addServices,
      addServicesCt: addServices.length
    });
  } catch (err) {
    logger.log('trackOnetimeAddSrvcs', err);
  }
}

export async function trackOnetimeSrvcDateSel(userInfo, state) {
  try {
    const serviceTitle = getServiceTitle(state.booking.serviceType, state);
    const addServices = getAddServicesTitles(state.booking.addons, state);
    analytics.track('Onetime Service Date Selected', {
      ...userInfo,
      serviceType: serviceTitle,
      addServices: addServices,
      addServicesCt: addServices.length,
      serviceDate: state.booking.cleanDate.momentDate
    });
  } catch (err) {
    logger.log('trackOnetimeSrvcDateSel', err);
  }
}

export async function trackOnetimeAdditionalInstructions(bookingId, note) {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    analytics.track('Additional Instructions Added', {
      ...userInfo,
      bookingID: bookingId,
      addInstructions: note
    });
  } catch (err) {
    logger.log('trackOnetimeAdditionalInstructions', err);
  }
}

//end Onetime track calls

//recurring track calls
export async function trackRecurOptSel(userInfo, state) {
  //for recurring field if want title below else for interal name use state.schedule.currentPackage
  // state.schedule.allPackages[state.schedule.currentPackage].title
  try {
    const recurInitialFields = fmtRecurInitialFields(state);
    analytics.track('Recurring Options Selected', {
      ...userInfo,
      ...recurInitialFields
    });
  } catch (err) {
    logger.log('trackRecurOptSel', err);
  }
}

export async function trackRecurAddSrvcs(userInfo, state) {
  try {
    const recurInitialFields = fmtRecurInitialFields(state);
    const addServices = recurAddSvcsformatter(state);

    analytics.track('Recurring Add Services Selected', {
      ...userInfo,
      ...recurInitialFields,
      //add services
      addServices: addServices,
      addServicesCt: addServices.length
    });
  } catch (err) {
    logger.log('trackRecurAddSrvcs', err);
  }
}

export async function trackRecurStartDateSel(userInfo, state) {
  try {
    const addServices = recurAddSvcsformatter(state);
    const recurInitialFields = fmtRecurInitialFields(state);

    analytics.track('Recurring Start Date Selected', {
      ...userInfo,
      ...recurInitialFields,
      //add services
      addServices: addServices,
      addServicesCt: addServices.length,

      startDate: state.schedule.startDate
    });
  } catch (err) {
    logger.log('trackRecurStartDateSel', err);
  }
}
// end recurring track calls

export async function trackRecurSrvsBooked(
  coupon,
  bookingResult,
  scheduledItems,
  costs
) {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    const recurInitialFields = fmtRecurInitialFields(state);
    const addServices = recurAddSvcsformatter(state);

    const revenue = costs.map(clean => clean.cost).reduce((a, b) => a + b, 0);
    let couponDiscount = costs
      .map(clean => clean.couponDetails.valueOff)
      .reduce((a, b) => a + b, 0);
    couponDiscount = couponDiscount ? couponDiscount : 0;
    const priceBeforeCoupon = revenue + couponDiscount;

    const serviceDates = bookingResult.cycle.map(clean => clean.serviceDate);
    const payload = {
      ...userInfo,
      ...recurInitialFields,
      phone: state.auth.me.phone,
      //add services
      addServices: addServices,
      addServicesCt: addServices.length,
      startDate: state.schedule.startDate,
      serviceFrequency: state.booking.frequency,
      serviceDates: serviceDates,
      couponCode: coupon,
      discount: couponDiscount,
      priceBeforeCoupon: priceBeforeCoupon,
      revenue: revenue,
      recurringBookingID: bookingResult.recurringBookingID
    };
    analytics.track('Order Completed', {
      order_id: bookingResult.recurringBookingID,
      revenue: revenue,
      discount: couponDiscount,
      coupon: coupon,
      currency: 'USD',
      products: [
        {
          name: recurInitialFields.recurring,
          price: priceBeforeCoupon, //(includes recurring discount)
          quantity:
            recurInitialFields.hotelStyleCt + recurInitialFields.deepCleanCt,
          category: state.booking.frequency
        }
      ],
      // add the browser fingerprint to the Segment
      browser_fingerprint_id: userInfo.browser_fingerprint_id
    });
    if (state.booking.isPMBooking) {
      const recipientInfo = fmtRecipientInfo(state, true);
      analytics.track('PM Service Booked', {
        ...payload,
        ...recipientInfo
      });
    } else {
      analytics.track('Service Booked', payload);
      analytics.track('Recurring Booked', payload);
    }
    let datesReceived = [];
    let rescheduledItem = false;
    for (var i = 0; i < scheduledItems.length; i++) {
      if (scheduledItems[i].rescheduleDate) {
        datesReceived.push(
          scheduledItems[i].rescheduleDate.format('YYYY-MM-DD')
        );
        rescheduledItem = true;
      } else if (scheduledItems[i].skip) {
        datesReceived.push('');
        rescheduledItem = true;
      } else {
        datesReceived.push(bookingResult.cycle[i].serviceDate);
      }
    }
    if (rescheduledItem) {
      let serviceTypes = [];
      let timeWindows = [];
      let addServicesCount = [];
      for (let i = 0; i < bookingResult.cycle.length; i++) {
        serviceTypes.push(
          getServiceTitle(bookingResult.cycle[i].serviceType, state)
        );
        timeWindows.push(bookingResult.cycle[i].timeframe);
        if (bookingResult.cycle[i].additionalService) {
          addServicesCount.push(
            bookingResult.cycle[i].additionalService.length
          );
        } else {
          addServicesCount.push(0);
        }
      }
      analytics.track('Package Dates Changed', {
        ...userInfo,
        regionID: state.auth.me.region.regionID,
        bedroomsCount: state.auth.me.bedroomsCount,
        addServicesCount: addServicesCount,
        serviceTypes: serviceTypes,
        timeWindows: timeWindows,
        datesRequested: serviceDates,
        datesReceived: datesReceived
      });
    }
  } catch (err) {
    logger.log('trackRecurringBooked', err);
  }
}

export async function trackOnetimeSrvsBooked(result, coupon) {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    const serviceTitle = getServiceTitle(state.booking.serviceType, state);
    const addServices = getAddServicesTitles(state.booking.addons, state);

    const payload = {
      ...userInfo,
      phone: state.auth.me.phone,
      hotelStyleCt:
        state.booking.serviceType === SERVICE_TYPES.HOTEL_STYLE ? 1 : 0,
      deepCleanCt:
        state.booking.serviceType === SERVICE_TYPES.DEEP_CLEAN ? 1 : 0,
      serviceFrequency: state.booking.frequency,
      addServices: addServices,
      addServicesCt: addServices.length,
      couponCode: coupon,
      discount: result.cost.couponDetails.valueOff,
      priceBeforeCoupon: result.cost.beforeDiscountCost,
      revenue: parseFloat(result.price),
      //one time fields
      serviceDate: state.booking.cleanDate.momentDate,
      serviceType: serviceTitle,
      bookingID: result.bookingID,
      timeframe: result.timeframe
    };
    analytics.track('Order Completed', {
      order_id: result.bookingID,
      revenue: parseFloat(result.price),
      discount: result.cost.couponDetails.valueOff,
      coupon: coupon,
      currency: 'USD',
      products: [
        {
          name: serviceTitle,
          price: result.cost.beforeDiscountCost, //price without discount
          quantity: 1,
          category: state.booking.frequency
        }
      ],
      // add the browser fingerprint to the Segment
      browser_fingerprint_id: userInfo.browser_fingerprint_id
    });
    if (state.booking.isPMBooking) {
      const recipientInfo = fmtRecipientInfo(state, true);
      analytics.track('PM Service Booked', {
        ...payload,
        ...recipientInfo
      });
    } else {
      analytics.track('Service Booked', payload);
    }
  } catch (err) {
    logger.log('trackOnetimeSrvsBooked', err);
  }
}

export async function trackCleaningUpdated(result) {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    const cc = CleansSelectors.selectCurrentClean(state);
    const addServicesOld = cc.additionalService
      .map(currentClean => {
        return currentClean.title ? currentClean.title : [];
      })
      .sort();
    const addServices = getAddServicesTitles(
      result.additionalService,
      state
    ).sort();
    const serviceTitle = getServiceTitle(result.serviceType, state);
    const serviceOld = {
      addServicesOld: addServicesOld === addServices ? '' : addServicesOld,
      addServicesCtOld:
        addServicesOld.length === addServices.length
          ? ''
          : addServicesOld.length,
      serviceDateOld:
        cc.momentServiceDate._i === result.serviceDate
          ? ''
          : cc.momentServiceDate._i,
      serviceTypeOld:
        cc.serviceType.title === serviceTitle ? '' : cc.serviceType.title,
      timeframeOld: cc.timeframe === result.timeframe ? '' : cc.timeframe
    };
    analytics.track('Cleaning Updated', {
      ...userInfo,
      //old
      ...serviceOld,
      //differences
      priceDifference: result.price - cc.price,
      addServicesDifference: addServices.length - addServicesOld.length,
      serviceDateChange: cc.SeviceDate === result.ServiceDate ? false : true,
      //new
      addServices: addServices,
      addServicesCt: addServices.length,
      serviceDate: result.serviceDate,
      serviceType: serviceTitle,
      timeframe: result.timeframe,
      //new field no tracking old
      priceBeforeCoupon: result.cost.beforeDiscountCost,
      revenue: result.price,
      couponCode: get(result, 'cost.couponDetails.coupon', ''),
      discount: get(result, 'cost.couponDetails.valueOff', 0),
      addInstructions: result.notes
    });
  } catch (err) {
    logger.log('trackCleaningUpdated', err);
  }
}

export async function trackCleaningCanceled(currentClean) {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    const addServices = currentClean.additionalService.map(currentClean => {
      return currentClean.title ? currentClean.title : [];
    });
    analytics.track('Cleaning Canceled', {
      ...userInfo,
      addServices: addServices,
      addServicesCt: addServices.length,
      couponCode: currentClean.cost.couponDetails.coupon,
      priceBeforeCoupon: currentClean.cost.beforeDiscountCost,
      discount: currentClean.cost.couponDetails.valueOff,
      revenue: parseFloat(currentClean.price),
      serviceDate: currentClean.momentServiceDate,
      serviceType: currentClean.serviceType.title,
      timeframe: currentClean.timeframe
    });
  } catch (err) {
    logger.log('trackCleaningCanceled', err);
  }
}

// end booking/scheduling flow

//account page track calss

export async function trackBuildingChanged(
  propertyID,
  propertyName,
  bedroomsCount,
  restValues
) {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    const user = AuthSelectors.selectCurrentUser(state);
    const propertyNameOld =
      user.propertyID === propertyID ? '' : user.propertyName;
    const unitNoOld =
      user.unitNumber === restValues.unitNumber ? '' : user.unitNumber;
    const bedroomCtOld =
      user.bedroomsCount === bedroomsCount.value ? '' : user.bedroomsCount;
    if (
      [propertyNameOld, unitNoOld, bedroomCtOld].some(value => value !== '')
    ) {
      analytics.track('Building Change', {
        ...userInfo,
        propertyNameOld: propertyNameOld,
        propertyName: propertyName,
        unitNoOld: unitNoOld,
        unitNo: restValues.unitNumber,
        bedroomCtOld: bedroomCtOld,
        bedroomCt: bedroomsCount.value,
        pets: restValues.hasPets
      });
    }
  } catch (err) {
    logger.log('trackBuildingChanged', err);
  }
}

export async function trackCouponCode() {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    analytics.track('Coupon Code Added', {
      ...userInfo,
      couponCode: ''
    });
  } catch (err) {
    logger.log('trackCouponCode', err);
  }
}

async function updateEmail(currentEmail, newEmail) {
  // eslint-disable-next-line max-len
  const updateEmailEndpoint = `https://api.iterable.com/api/users/updateEmail?api_key=${process.env.ITERABLE_ID}`;
  try {
    const response = await axios.post(updateEmailEndpoint, {
      currentEmail: currentEmail,
      newEmail: newEmail
    });
    return response.data;
  } catch (error) {
    return error;
  }
}

export async function trackAccountEdit(values) {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    const user = AuthSelectors.selectCurrentUser(state);
    const userOld = {
      firstNameOld: user.firstName === values.firstName ? '' : user.firstName,
      lastNameOld: user.lastName === values.lastName ? '' : user.lastName,
      emailOld: user.email === values.email ? '' : user.email,
      phoneOld: user.phone === values.phone ? '' : user.phone
    };
    let iterableResp;
    if (userOld.emailOld && userOld.email != '') {
      iterableResp = await updateEmail(userOld.emailOld, values.email);
    }
    if (Object.values(userOld).some(value => value !== '')) {
      analytics.track('Account Edit', {
        ...userInfo,
        ...userOld,
        ...values,
        iterableEmailResp: iterableResp
      });
    }
  } catch (err) {
    logger.log('trackAccountEdit', err);
  }
}

export async function trackPayInfoChanged() {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    analytics.track('Payment Information Changed', {
      ...userInfo,
      ccExpiry: state.auth.me.ccExpiry,
      ccLast4: state.auth.me.ccLast4
    });
  } catch (err) {
    logger.log('trackPayInfoChanged', err);
  }
}

export async function trackSrvDiscontinued(activeSubscription, reason) {
  try {
    const discontinueDate = moment(Date.now()).format('YYYY-MM-DD');
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    const serviceCts = getRecSrvCts(activeSubscription.cycle);
    const addonsArray = activeSubscription.cycle
      .map(clean => {
        return clean.additionalService ? clean.additionalService : [];
      })
      .flat();
    const addServices = getAddServicesTitles(addonsArray, state);
    const cleanList = CleansSelectors.selectCleansList(
      state,
      CLEANS_LIST_TYPE.FUTURE
    );
    const recurringCleans = cleanList
      .filter(clean => clean.isRecurring === true)
      .reverse();
    let couponCode;
    if (recurringCleans.length > 0) {
      couponCode = recurringCleans[0].cost.couponDetails.coupon;
    }
    analytics.track('Service Discontinued', {
      ...userInfo,
      phone: state.auth.me.phone,
      hotelStyleCt: serviceCts[SERVICE_TYPES.HOTEL_STYLE],
      deepCleanCt: serviceCts[SERVICE_TYPES.DEEP_CLEAN],
      addServices: addServices,
      addServicesCt: addServices.length,
      discontinueDate: discontinueDate,
      discontinueMessage: reason,
      recurringBookingID: activeSubscription.recurringBookingID,
      recurring: state.schedule.allPackages[activeSubscription.package].title,
      cycleLength: activeSubscription.cycleLength,
      couponCode: couponCode
    });
  } catch (err) {
    logger.log('trackSrvDicontinued', err);
  }
}

export async function trackSrvPaused(activeSubscription, resumeDate, reason) {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    const serviceCts = getRecSrvCts(activeSubscription.cycle);
    const addonsArray = activeSubscription.cycle
      .map(clean => {
        return clean.additionalService ? clean.additionalService : [];
      })
      .flat();
    const addServices = getAddServicesTitles(addonsArray, state);

    const cleanList = CleansSelectors.selectCleansList(
      state,
      CLEANS_LIST_TYPE.FUTURE
    );
    const upcomingService = cleanList.filter(
      clean => clean.isRecurring === true
    )[0];
    let upcomingAddInsructions,
      upcomingServiceType,
      upcomingAddServices,
      couponCode;
    if (upcomingService) {
      couponCode = upcomingService.cost.couponDetails.coupon;
      upcomingAddInsructions = upcomingService.notes;
      upcomingServiceType = upcomingService.serviceType.title;
      upcomingAddServices = upcomingService.additionalService.map(
        addon => addon.title
      );
      // upcomingServiceDate = upcomingService.momentServiceDate;
    }
    analytics.track('Service Paused', {
      ...userInfo,
      phone: state.auth.me.phone,
      hotelStyleCt: serviceCts[SERVICE_TYPES.HOTEL_STYLE],
      deepCleanCt: serviceCts[SERVICE_TYPES.DEEP_CLEAN],
      addServices: addServices,
      addServicesCt: addServices.length,
      resumeDate: resumeDate,
      pauseMessage: reason,
      recurringBookingID: activeSubscription.recurringBookingID,
      recurring: state.schedule.allPackages[activeSubscription.package].title,
      cycleLength: activeSubscription.cycleLength,
      upcomingServiceType: upcomingServiceType,
      upcomingAddServices: upcomingAddServices,
      upcomingAddInstructions: upcomingAddInsructions,
      couponCode: couponCode
    });
  } catch (err) {
    logger.log('trackSrvPaused', err);
  }
}
//end Account page track calls

export async function trackReview(result) {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    const addServices = getAddServicesTitles(result.additionalService, state);
    const serviceTitle = getServiceTitle(result.serviceType, state);
    analytics.track('Review', {
      ...userInfo,
      phone: state.auth.me.phone,
      unitNo: state.auth.me.unitNumber,
      houseKeeper: 'hk data not populated',
      feedBack: result.ratingComment,
      rating: result.rating,
      serviceDate: result.serviceDate,
      addServices: addServices,
      serviceType: serviceTitle,
      timeframe: result.timeframe,
      addInstructions: result.notes
    });
  } catch (err) {
    logger.log('trackReview', err);
  }
}

export async function trackSetRecuringService(selected, serviceType, addons) {
  try {
    const state = store.getState();
    const userInfo = await fmtUserInfo(state);
    const addServices = getAddServicesTitles(addons, state);
    const serviceTitle = getServiceTitle(serviceType, state);
    analytics.track('Set Recurring Service', {
      ...userInfo,
      serviceFrequency: selected,
      addServices: addServices,
      serviceType: serviceTitle
    });
  } catch (err) {
    logger.log('trackSetRecurringService', err);
  }
}
